import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, TextField, Grid } from '@material-ui/core';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { getTomorrowDate } from '../../utils/dates';
import { makeStyles } from '@material-ui/core';
import { useMutation } from 'react-query';
import { createTodo } from '../../api/objective/todo.api';
import { addAlert } from '../../actions/alerts.action';

const useStyles = makeStyles(theme => ({
  addBtn: {
    marginTop: '20px'
  },
  container: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  datepicker: {
    minWidth: '170px'
  }
}));

const NewTodo = ({
  objectiveId,
  onSubmitSuccess
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [ name, setName ] = useState('');
  const [ deadline, setDeadline ] = useState(null);
  const [ validation, setValidation ] = useState({ name: false, deadline: true });

  const createTodoMutation = useMutation(
    async () => {
      return await createTodo({
        objectiveId,
        todo: { name, deadline, objectiveId }
      });
    },
    {
      onSuccess: () => {
        onSubmitSuccess();
        setName('');
        setDeadline(null);
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const handleOnChangeName = event => {
    setName(event.target.value);
    setValidation({
      ...validation,
      name: event.target.value.length !== 0
    });
  };

  const handleDeadlineChange = date => {
    setDeadline(date);
    setValidation({
      ...validation,
      deadline: !date || !isNaN(Date.parse(date))
    });
  };

  const handleAddTodo = () => {
    if (validation.name && validation.deadline) {
      createTodoMutation.mutate();
    }
  };
  return (
    <>
      <Grid container spacing={ 2 } className = { classes.container }>
        <Grid item xs={ 8 }>
          <TextField
            value={ name }
            onChange={ handleOnChangeName }
            fullWidth={ true }
            placeholder={ t('objective.todos.create.name.placeholder') }
          ></TextField>
        </Grid>
        <Grid item xs={ 4 }>
          <KeyboardDatePicker
            className={ classes.datepicker }
            value={ deadline }
            error={ !validation.deadline }
            helperText={ !validation.deadline ? t('objective.todos.create.deadline.error') : '' }
            autoOk={ true }
            disableToolbar
            variant="inline"
            format="yyyy/MM/dd"
            onChange={ handleDeadlineChange }
            minDate={ getTomorrowDate() }
            placeholder={ t('objective.todos.create.deadline.placeholder') }
            KeyboardButtonProps={ {
              'aria-label': 'change date',
              position: 'start'

            } }
            keyboardIcon={
              <DateRangeOutlinedIcon />
            }
          />
        </Grid>
      </Grid>
      <Button
        className={ classes.addBtn }
        variant='contained'
        color="secondary"
        onClick={ handleAddTodo }
        disabled={ !validation.name || !validation.deadline }
      >
        { t('objective.todos.create.add.btn') }
      </Button>
    </>
  );
};

export default NewTodo;
